import React, { useEffect, useState } from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import { DateUtils } from 'react-day-picker'

import AddWeeklyRounds from './add_weekly_rounds'
import AddRoundsManually from './add_rounds_manually'
import { initialWeekDays } from './week_days'
import { FaIcon } from '../index'
import { formatDate } from '../../helpers'

const ScheduleRounds = ({
  details,
  setDetails,
  dayRoundNumber,
  setDayRoundNumber,
  givenDays,
  setGivenDays,
  startDate,
  setStartDate,
  numberOfWeeks,
  setNumberOfWeeks,
  selectedButton,
  setSelectedButton,
  selectedWeekDays,
  setSelectedWeekDays,
  lockedDates = [],
  showHeader = true,
  defaultSelectedButton = 'manually',
  customerDateFormat,
}) => {
  // Persisted rounds tag their Date with roundId (see RoundSchedulerRoot.parseRounds), so
  // same-date rounds stay distinguishable - only the scored round is locked, not its date.
  // Untagged dates fall back to value comparison (instances get replaced on server reloads).
  const isLocked = (day) => lockedDates.some(locked => (
    locked.roundId || day.roundId ? locked.roundId === day.roundId : +locked === +day
  ))
  const [numberOfExistingRounds, setNumberOfExistingRounds] = useState(0)

  useEffect(() => {
    if (details.rounds) {
      if (details.actionType === 'cloneEvent') {
        setNumberOfExistingRounds(details.rounds.length)
      }

      details.rounds.map(round => {
        if (typeof round === 'string')
          setDetails({ ...details, rounds: [] })
      })
    }
    setSelectedButton(defaultSelectedButton)
  }, [])

  useEffect(() => {
    if (details.rounds != [])
      setDayRoundNumber(dayRoundNumber)
  }, [details.rounds])

  const handleClick = (e, val) => {
    e.preventDefault()
    setSelectedButton(val)
  }

  const handleClearAll = () => {
    setDetails({ ...details, rounds: details.rounds.filter(day => isLocked(day)), manuallyRounds: details.manuallyRounds.filter(day => isLocked(day)), weeklyRounds: [] })
    setStartDate('')
    setNumberOfWeeks('')
    setGivenDays([])
    setSelectedWeekDays(initialWeekDays())
  }

  const handleDeleteRound = (e, day) => {
    e.preventDefault()
    if (isLocked(day)) {
      return
    }
    let found = false
    let remainingDays = details.rounds && details.rounds.filter(value => {
        if (value === day && !found) {
            found = true
            return false
        }
        return true
    })

    let foundManual = false
    let remainingManualDays = details.manuallyRounds && details.manuallyRounds.filter(value => {
        if (value === day && !foundManual) {
            foundManual = true
            return false
        }
        return true
    })

    setDetails({ ...details, rounds: remainingDays, manuallyRounds: remainingManualDays })
    setDayRoundNumber(remainingDays.length)

    let dayRounds = remainingDays.filter(selectedDay =>
      DateUtils.isSameDay(selectedDay, day)
    ).length

    let deletedDay = document.querySelectorAll(`div[aria-label="${String(moment(day).format('ddd MMM DD YYYY'))}"]`)
    deletedDay.forEach(dayCell => {
      dayCell.className = `DayPicker-Day DayPicker-Day--selected multiple--${dayRounds}`
    })
  }

  const selectedRoundDisplay = (day) => {
    return (
      <span className='selected_round'>
        <span className='round_name'>
          { formatDate(day, null, 'MMM DD') }
        </span>
        <button type='button' className='delete_round_button' onClick={ (e) => handleDeleteRound(e, day) } disabled={ isLocked(day) }>
          <img src={require('delete_button.svg')} />
        </button>
      </span>
    )
  }

  let infoText = ''
  if (details.actionType === 'createEvent') {
    infoText = window.I18n.t('shared.components.schedule_rounds.rounds_selected', {count: details.rounds.length})
  } else {
    infoText = window.I18n.t('shared.components.schedule_rounds.selected_dates_info', {selected: details.rounds.length, total: numberOfExistingRounds})
  }

  return (
    <div className='popup_form_content schedule_rounds'>
      { showHeader &&
        <>
          <h2>{ window.I18n.t('shared.components.schedule_rounds.rounds_header') }</h2>
          <p className='content_information rounds_selected'>{ infoText }</p>
        </>
      }
      <span className='type_of_rounds_container'>
        <button type='button' className={`type_button ${selectedButton === 'manually' ? 'selected' : ''}`} onClick={ (e) => handleClick(e, 'manually') } >
          <FaIcon icon={ 'calendar-days' } />
          { window.I18n.t('shared.components.schedule_rounds.add_rounds_manually') }
        </button>
        <button type='button' className={`type_button ${selectedButton === 'weekly' ? 'selected' : ''}`} onClick={ (e) => handleClick(e, 'weekly') } >
          <FaIcon icon={ 'arrows-rotate' } />
          { window.I18n.t('shared.components.schedule_rounds.generate_weekly_rounds') }
        </button>
      </span>
      { selectedButton === 'manually' ?
        <AddRoundsManually
          details={ details }
          setDetails={ setDetails }
          dayRoundNumber={ dayRoundNumber }
          setDayRoundNumber={ setDayRoundNumber }
          numberOfExistingRounds={ numberOfExistingRounds }
        /> :
        <AddWeeklyRounds
          details={ details }
          setDetails={ setDetails }
          selectedWeekDays={ selectedWeekDays }
          setSelectedWeekDays={ setSelectedWeekDays }
          givenDays={ givenDays }
          setGivenDays={ setGivenDays }
          startDate={ startDate }
          setStartDate={ setStartDate }
          numberOfWeeks={ numberOfWeeks }
          setNumberOfWeeks={ setNumberOfWeeks }
          dayRoundNumber={ dayRoundNumber }
          setDayRoundNumber={ setDayRoundNumber }
          numberOfExistingRounds={ numberOfExistingRounds }
          customerDateFormat={ customerDateFormat }
        />
      }
      <span className='selected_rounds_container'>
        <span className='selected_rounds_info'>
          <p>{ window.I18n.t('shared.components.schedule_rounds.rounds_header') }</p>
          <span>{ details.rounds.length }</span>
        </span>
        { details.rounds.length > 0 &&
          <button type='button' className='clear_all_button' onClick={ handleClearAll }>
            { window.I18n.t('shared.components.schedule_rounds.clear_all') }
          </button>
        }
      </span>
      <span className='selected_rounds'>
        { details.rounds && details.rounds.sort( (a,b) => a - b ).map( day => {
          return selectedRoundDisplay(day)
        })}
      </span>
    </div>
  )
}

ScheduleRounds.propTypes = {
  details: PropTypes.object.isRequired,
  setDetails: PropTypes.func.isRequired,
  dayRoundNumber: PropTypes.object.isRequired,
  setDayRoundNumber: PropTypes.func.isRequired,
  givenDays: PropTypes.array.isRequired,
  setGivenDays: PropTypes.func.isRequired,
  startDate: PropTypes.oneOfType([ PropTypes.string, PropTypes.instanceOf(Date) ]).isRequired,
  setStartDate: PropTypes.func.isRequired,
  numberOfWeeks: PropTypes.string.isRequired,
  setNumberOfWeeks: PropTypes.func.isRequired,
  selectedButton: PropTypes.string.isRequired,
  setSelectedButton: PropTypes.func.isRequired,
  selectedWeekDays: PropTypes.object.isRequired,
  setSelectedWeekDays: PropTypes.func.isRequired,
  lockedDates: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  showHeader: PropTypes.bool,
  defaultSelectedButton: PropTypes.string,
  customerDateFormat: PropTypes.string,
}

export default ScheduleRounds